/**
 * Numeral is having issue with rounding small numbers,
 *  so we will do our rounding before passing the value into numeral
 *  and after the PR is merged
 *  https://github.com/adamwdraper/Numeral-js/pull/635
 * @param {number} decimals | number of decimal places
 * @param {number} price | price to format
 * @returns {number} rounded and fixed decimal place number
 */
export const toFixed = decimals => price => {
  const power = Math.pow(10, decimals)
  return (Math.round(price * power) / power).toFixed(decimals)
}
